import React from "react"
import Logo from "./Logo"
import Navbar from "./Navbar"

export default function Neader() {
	return (
		<header>
			<Logo />
			<Navbar />
		</header>
	)
}
